enum BorderRadius {
  regular = 5,
  small = 2
}
export default BorderRadius;

export type BorderRadiusNames = keyof typeof BorderRadius;
